import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { pick } from 'Helpers/Affordances';
import { RoadmapDeliverableGoalDetailOutcomesSelector } from './components/RoadmapGoalDetailOutcomesSelector/RoadmapDeliverableGoalDetailOutcomesSelector';
import { GuidedHouseholdReviewLayoutGoalDetailOutcomesSelector } from './components/RoadmapGoalDetailOutcomesSelector/GuidedHouseholdReviewLayoutGoalDetailOutcomesSelector';
import { RoadmapGoalDetailsStepLayout } from './RoadmapGoalDetailsStepLayout';

const roadmapDeliverableMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('outcomes', {
    _component: () => RoadmapDeliverableGoalDetailOutcomesSelector,
  }, overrideReadOnly)
  .done();
const guidedHouseholdReviewMetaOverrideSet = buildBaseOverrides()
  .nameOverride('outcomes', {
    _component: () => GuidedHouseholdReviewLayoutGoalDetailOutcomesSelector,
  }, overrideReadOnly)
  .done();

const RoadmapGoalDetailsStepTemplate = ({ resource }) => {
  const metaOverrideSet = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: guidedHouseholdReviewMetaOverrideSet,
  }, roadmapDeliverableMetaOverrideSet);
  return (
    <MetaResourceRenderer
      layout={RoadmapGoalDetailsStepLayout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

RoadmapGoalDetailsStepTemplate.defaultProps = {
};

RoadmapGoalDetailsStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { RoadmapGoalDetailsStepTemplate };
